/**
 * 异步请求错误处理
 */
import { routerRedux } from 'dva/router';
import ZlbConfirm from '@/components/ZlbConfirm';
import { tracer } from '@zcy/zlb-utils';

const { zlbSpm } = tracer;

const error = (e, dispatch) => {
  if (e.status === 400) {
    ZlbConfirm({
      title: '抱歉，系统开小差了~',
      content: e.data.message,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  if (e.status === 403) {
    dispatch(routerRedux.push('/claim/exception/403'));
  }
  if (e.status >= 404 && e.status < 422) {
    dispatch(routerRedux.push('/claim/exception/404'));
  }
  if (e.status <= 504 && e.status >= 500) {
    ZlbConfirm({
      title: '服务器内部错误，无法完成请求',
      showOkBtn: false,
      cancelText: '知道了',
    });

    zlbSpm({
      actionData: e?.request?.responseURL
    }, {
      flag: 'systemError',
    })
  }
};

export default error;
